import type { IRedirectCase } from "../types";

import { campaignAccessRedirectHandler } from "./campaign-access";
import { durationResetHandler } from "./duration-reset";
import { homepageRedirectHandler } from "./homepage-redirect";
import { allowOnlyDeclaredParams } from "./params-reset";

export { homepageRedirectHandler } from "./homepage-redirect";

export const keywordsRedirectCases: IRedirectCase[] = [
    {
        name: "homepage",
        handler: homepageRedirectHandler,
    },
    {
        name: "campaignAccess",
        handler: campaignAccessRedirectHandler,
    },
    {
        name: "durationReset",
        handler: durationResetHandler,
    },
    {
        name: "paramsReset",
        handler: allowOnlyDeclaredParams,
    },
] as const;
